module.exports = __webpack_public_path__ + "static/media/shopping.822cf898.jpeg";